<div class="header">
  <div class="action">
    <div class="close" (click)="close(GeneralConfirmationModalResult.None)">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="modal-header">
  <h3 class="modal-title">{{ 'cancellation-contract-modal.title' | translate }}</h3>
</div>

<div class="modal-body form">
  <div class="row form-field">
    <div class="title">
      <p class="subtitle-14">{{ 'cancellation-contract-modal.end-date-title' | translate }}</p>
    </div>

    <div class="input">
      <div class="form-field-date">
        <input matInput
               class="input"
               placeholder="{{ 'cancellation-contract-modal.date-placeholder' | translate }}"
               [matDatepicker]="contractEndDate"
               (click)="contractEndDate.open()"
               [(ngModel)]="selectedDate">
        <mat-datepicker-toggle matSuffix [for]="contractEndDate"></mat-datepicker-toggle>
        <mat-datepicker #contractEndDate></mat-datepicker>
      </div>
    </div>
  </div>

  <div class="hint-text">
    <p class="body-12">{{ 'cancellation-contract-modal.hint-text' | translate:{ petName: petName } }}</p>
  </div>
</div>

<div class="modal-footer">
  <button [disabled]="!selectedDate" (click)="close(selectedDate!)"
          class="button primary">{{ 'cancellation-contract-modal.submit' | translate }}
  </button>
</div>
